import { styled } from "@mui/material";

export const LayoutHeader = styled("p")`
  font-weight: 600;
  font-size: 3.2rem;
  line-height: 4rem;
  color: #335642;

  @media screen and (max-width: 540px) {
    display: flex;
    justify-content: center;
    margin-block-end: 2rem;
  }
`;
export const PreviousPage = styled("p")`
  font-size: 2rem;
  text-align: center;
  display: flex;
  align-items: center;
  font-weight: 400;
  margin-block-end: 2rem;
  color: #335642;
  gap: 1rem;
  cursor: pointer;
`;

export const OpenModalButton = styled("button")`
  background: #335642;
  border-radius: 0.4rem;
  font-weight: 600;
  font-size: 1.4rem;
  color: #ffffff;
  padding-inline: 2.8rem;
  padding-block: 1.2rem;
  color: #ffffff;
  cursor: pointer;
  border-width: 0;
  outline: none;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  width: fit-content;

  @media screen and (max-width: 340px) {
    padding-inline: 1rem;
  }
`;

export const Button = styled("button")`
  background: #335642;
  border-radius: 0.4rem;
  font-weight: 600;
  font-size: 1.4rem;
  color: #ffffff;
  padding-inline: 2.8rem;
  padding-block: 1.2rem;
  color: #ffffff;
  cursor: pointer;
  border-width: 0;
  outline: none;
  display: flex;
  align-items: center;
  gap: 0.9rem;

  @media screen and (max-width: 340px) {
    padding-inline: 1rem;
    width: 100%;
  }
`;

export const WhiteBackGroundButton = styled("button")`
  background: #fffff;
  border-radius: 0.4rem;
  font-weight: 600;
  font-size: 1.4rem;
  color: #335642;
  padding-inline: 2.8rem;
  padding-block: 1.2rem;
  cursor: pointer;
  border-width: 0;
  outline: none;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  border: 1px solid #335642;

  @media screen and (max-width: 340px) {
    padding-inline: 1rem;
    width: 100%;
  }
`;
export const Wrapper = styled("main")`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SideBarChildren = styled("p")`
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 4rem;
  color: #335642;
  margin-block-start: 4rem;

  @media screen and (max-width: 540px) {
    display: flex;
    justify-content: center;
    margin-block-end: 2rem;
  }
`;

export const customStyles = {
  content: {
    // top: "50%",
    // left: "50%",
    // right: "auto",
    // bottom: "auto",
    // // marginRight: "-50%",
    // transform: "translate(-50%, -50%)",
    // padding: "0rem",
    // borderRadius:"1rem",
    // maxWidth: '-webkit-fill-available'

    height: "85%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "60%",
    transform: "translate(-50%, -50%)",
    padding: "0rem",
      width: "60rem",
    maxWidth: "100%",
    border: "none",
    borderRadius: "0px",

      zIndex: 2100,

    
  },
  overlay: {
    zIndex: 2050,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};
export const applicationCustomStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    // marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0rem",
    borderRadius: "1rem",

    width: "80rem",
    maxWidth: "100%",
    // border: "none",
  },
};

export const Section = styled("section")`
  // background-color: #fff;
  padding-block-end: 2rem;
  //   padding-inline: 20rem;
  max-height: 68.2rem;
  // overflow-y: auto;

  @media (min-width: 912px) {
    min-width: 46rem !important;
    // overflow-x: hidden;
  }
`;

export const Heading = styled("h4")`
  font-weight: 700;
  font-size: 3.9em;
  color: #ffffff;
  padding-block: 2.4rem;
  padding-inline: 3rem;
  background-image: linear-gradient(#335642, #8dc467);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: fixed;
  z-index: 1000;

  & > div {
    border-bottom: 3px solid #8dc467;
  }

  @media (max-width: 540px) {
    font-size: 2rem;
  }
`;

export const FileText = styled("p")`
  font-size: 1.5rem;
`;
export const FileText1 = styled("p")`
  font-size: 1.3rem;
  color: #959aa4;
`;

export const Shown = styled("section")`
  font-size: 1.6rem;
  margin-block: 2rem;
`;

export const NoData = styled("h1")`
  border-bottom: 1;
  font-size: 2rem;
  display: flex;
  justify-content: center;
`;

export const FormWrapper = styled("main")`
  margin: auto;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  max-width: auto;
  padding-inline: clamp(2rem, 3vw, 5.6rem);
  background: #ffffff !important;
`;

export const TimeWrapper = styled("span")`
  display: flex;
  align-items: end;
  gap: 1rem;
`;

export const TimeBG = styled("p")`
  font-size: 1.6rem;
  border: #8dc467 solid 1px;
  // border-radius: 4px;
  padding-inline: 1.2rem;
  // border-top-left-radius:0px;
  // border-top-right-radius:0px;
  cursor: pointer;
  // background-color:  #8DC467;
  // margin-block-start: 4.2em;
`;

export const FormatWrapper = styled("span")`
  margin-block-end: 2.2em;
`;

export const Free = styled("span")`
  display: flex;
  align-self: center;
  font-size: 1.5rem;
  margin-block: 2rem;
  color: green;
`;
export const GreenText = styled("span")`
  font-size: 2rem;
  color: green;
`;

export const DisplayError = styled("p")`
  color: red;
  font-size: 1.4rem;
  align-self: start;
`;
export const SubHeading = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-inline-end: 4rem !important;
  margin-block-end: 2rem;
  @media screen and (max-width: 540px) {
    flex-direction: column;
    justify-content: center;
    margin-inline: 1rem;
    gap: 1rem;
  }
`;
export const Info = styled("p")`
  font-weight: 700;
  font-size: 1.5rem;
  color: #050e0a;
`;

export const BtnContainer = styled("span")`
  display: flex;
  flex-direction: row;
  gap: 1.7rem;
`;
